export const LOCAL_STORAGE_PREFIX = "subtitle-ai-";
export const USER_LOGIN_DATA = "user-login-data";
// Define your session cookie name
export const SESSION_COOKIE_NAME = "subtitlemeai-session";

// video status constants
export const ALL_VIDEOS = "ALL";
export const QUEUED_VIDEOS = "QUEUED";
export const IN_PROGRESS_VIDEOS = "IN_PROGRESS";
export const PROCESSED_VIDEOS = "PROCESSED";
export const DRAFT_VIDEOS = "DRAFT";
export const FAILED_VIDEOS = "ERROR";

export const MAX_FREE_VIDEOS = 5;
export const MAX_VIDEO_LENGTH = 5;

export const KARAOKE = "karoke";
export const BACKGROUND = "background";

export const MAX_SIZE = 1 * 1024 * 1024 * 1024; // 1GB in bytes
export const validTypes = ["video/mp4", "video/x-m4v", "video/quicktime"];
export const validExtensions = ["mp4", "mov", "m4v"];

export const YOUTUBE = "youtube";
export const INSTAGRAM = "instagram";
export const TIKTOK = "tiktok";
